module.exports = __webpack_public_path__ + "img/28200.32a2d97c.jpg";